// Encabezado para las pestañas del módulo de configuración general
import { TabsList, TabsTrigger } from '@shared/components/ui/shadcn/tabs';
import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '@shared/hooks/usePermissions';

export const TabHeader = () => {
  const { t } = useTranslation('generalModule');
  const { canAccess } = usePermissions();

  // 🎯 Verificar permiso de edición
  const canEdit = canAccess(['tenant', 'tenant_3pl'], ['configuration.edit']);

  return (
    <div className="flex items-center justify-between">
      <TabsList className="mb-4">
        <TabsTrigger value="to_prepare">{t('tabs.to_prepare')}</TabsTrigger>
        <TabsTrigger value="rejected">{t('tabs.rejected')}</TabsTrigger>
      </TabsList>

      {canEdit && (
        <Button
          size="default"
          variant="primary"
          id="save-general"
          name="save-general"
          className="absolute right-3 sm:right-6 top-3"
          data-testid="save-general-button"
        >
          {t('modal.save')}
        </Button>
      )}
    </div>
  );
};
